import { useCallback, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { Input, Switch, Table, message } from "antd";
// import { Input, Modal, Switch, Table, message } from "antd";
import PageTitle from "../../components/PageTitle";
import {
  // adminLogin,
  getStrictCheckinMeterGate,
  patchStrictCheckinMeterGateHouse,
  patchStrictCheckinMeterGatePlatform,
} from "../../api";
// import { setAdminAuthExtras } from "../../utils/adminPermissions";

/**
 * 严格入住房源列表。
 * 原：进页需再输一次当前管理员密码（防公用账号误点）；离开本页即失效。
 * 现：密码闸已注释，进入即显示列表（VIP白名单仍保留密码）。
 */
const StrictCheckinMeterGate = () => {
  // const navigate = useNavigate();
  // const [unlocked, setUnlocked] = useState(false);
  // const [gatePassword, setGatePassword] = useState("");
  // const [gateLoading, setGateLoading] = useState(false);
  const unlocked = true; // 密码闸关闭：直接进入
  const [platformOn, setPlatformOn] = useState(false);
  const [platformLoading, setPlatformLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [enabledFilter, setEnabledFilter] = useState("");

  const load = useCallback(async (p = page, ps = pageSize) => {
    setLoading(true);
    try {
      const res = await getStrictCheckinMeterGate({
        page: p,
        page_size: ps,
        keyword: keyword || undefined,
        enabled: enabledFilter || undefined,
      });
      if (res?.success) {
        setPlatformOn(!!res.data?.platform_enabled);
        setData(res.data?.list || []);
        setTotal(Number(res.data?.total || 0));
      } else {
        message.error(res?.error || "加载失败");
      }
    } catch {
      message.error("加载严格入住开关失败");
    } finally {
      setLoading(false);
    }
  }, [page, pageSize, keyword, enabledFilter]);

  useEffect(() => {
    if (!unlocked) return;
    load(page, pageSize);
  }, [unlocked, load, page, pageSize]);

  // const handleGateOk = async () => {
  //   const username = String(localStorage.getItem("admin_username") || "").trim();
  //   const password = String(gatePassword || "");
  //   if (!username) {
  //     message.error("未找到当前管理员账号，请重新登录");
  //     return;
  //   }
  //   if (!password) {
  //     message.error("请输入密码");
  //     return;
  //   }
  //   setGateLoading(true);
  //   try {
  //     const res = await adminLogin({ username, password });
  //     if (res && res.success === true) {
  //       if (res.token) localStorage.setItem("admin_token", res.token);
  //       if (res.user?.username) localStorage.setItem("admin_username", res.user.username);
  //       if (res.user) setAdminAuthExtras(res.user);
  //       setGatePassword("");
  //       setUnlocked(true);
  //       message.success("验证通过");
  //     } else {
  //       message.error(res?.error || "密码不正确");
  //     }
  //   } catch (e) {
  //     const msg =
  //       e?.response?.data?.error ||
  //       e?.response?.data?.message ||
  //       e?.message ||
  //       "密码不正确";
  //     message.error(msg === "Network Error" ? "网络异常，请重试" : msg);
  //   } finally {
  //     setGateLoading(false);
  //   }
  // };

  const onPlatformChange = async (checked) => {
    setPlatformLoading(true);
    try {
      const res = await patchStrictCheckinMeterGatePlatform({ enabled: checked ? 1 : 0 });
      if (res?.success) {
        setPlatformOn(!!res.data?.platform_enabled);
        message.success(checked ? "已打开平台总开关（仍须该栋房源开关也开才拦）" : "已关闭平台总开关（全部按现网）");
      } else {
        message.error(res?.error || "保存失败");
      }
    } catch {
      message.error("保存失败");
    } finally {
      setPlatformLoading(false);
    }
  };

  const onHouseChange = async (row, checked) => {
    try {
      const res = await patchStrictCheckinMeterGateHouse(row.id, { enabled: checked ? 1 : 0 });
      if (res?.success) {
        setData((prev) =>
          prev.map((h) =>
            h.id === row.id ? { ...h, strict_checkin_meter_gate: checked ? 1 : 0 } : h
          )
        );
      } else {
        message.error(res?.error || "更新失败");
      }
    } catch {
      message.error("更新失败");
    }
  };

  return (
    <div>
      <PageTitle title="严格入住房源列表" />
      {/* 进页密码闸（已关闭；恢复时取消注释并改回 unlocked 初始 false）
      <Modal
        title="进入 严格入住房源列表"
        open={!unlocked}
        closable={false}
        maskClosable={false}
        keyboard={false}
        confirmLoading={gateLoading}
        okText="验证进入"
        cancelText="返回"
        onOk={handleGateOk}
        onCancel={() => navigate("/system/roles/list")}
      >
        <div style={{ marginBottom: 12, fontSize: 13, color: "#666" }}>
          本页影响租客入住与水电操作，请再输入当前管理员密码。离开本页后需重新验证。
        </div>
        <Input.Password
          placeholder="管理员登录密码"
          value={gatePassword}
          onChange={(e) => setGatePassword(e.target.value)}
          onPressEnter={handleGateOk}
          autoFocus
        />
      </Modal>
      */}
      {/* {!unlocked ? (
        <div style={{ color: "#999", padding: "24px 0" }}>验证通过后显示列表</div>
      ) : ( */}
        <>
      <div style={{ marginBottom: 16, padding: 16, background: "#fff", borderRadius: 8 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
          <div>
            <div style={{ fontWeight: 600 }}>① 平台总开关</div>
            <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>
              与下面房源开关无先后：可先开某栋再开平台，也可反过来。只有「平台开 ∩ 该栋开」才拦水电；任一道关都走现网。
            </div>
          </div>
          <Switch checked={platformOn} loading={platformLoading} onChange={onPlatformChange} />
        </div>
      </div>
      <div style={{ marginBottom: 8, fontWeight: 600 }}>② 房源开关（始终可配，不必先开平台）</div>
      <div style={{ marginBottom: 12, display: "flex", gap: 8, alignItems: "center" }}>
        <Input.Search
          allowClear
          placeholder="房源名 / 地址 / 房东手机 / 房源ID"
          onSearch={(v) => {
            setKeyword(String(v || "").trim());
            setPage(1);
          }}
          style={{ maxWidth: 360 }}
        />
        <span style={{ fontSize: 12, color: "#888" }}>列表筛选：</span>
        <Switch
          checkedChildren="仅已开"
          unCheckedChildren="全部"
          checked={enabledFilter === "1"}
          onChange={(c) => {
            setEnabledFilter(c ? "1" : "");
            setPage(1);
          }}
        />
      </div>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={data}
        scroll={{ x: 720 }}
        pagination={{
          current: page,
          pageSize,
          total,
          showSizeChanger: true,
          onChange: (p, ps) => {
            setPage(p);
            setPageSize(ps);
          },
        }}
        columns={[
          { title: "ID", dataIndex: "id", width: 60 },
          {
            title: "房源开关",
            dataIndex: "strict_checkin_meter_gate",
            width: 72,
            render: (v, row) => (
              <Switch
                checked={Number(v) === 1}
                onChange={(c) => onHouseChange(row, c)}
              />
            ),
          },
          { title: "房源", dataIndex: "house_name", width: 160, ellipsis: true },
          { title: "地址", dataIndex: "address", width: 180, ellipsis: true },
          { title: "房东昵称", dataIndex: "real_name", width: 100, ellipsis: true },
          { title: "手机", dataIndex: "phone", width: 120 },
        ]}
      />
        </>
      {/* )} */}
    </div>
  );
};

export default StrictCheckinMeterGate;
